import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const Button = styled.button`
  background-color: ${({ theme }) => theme.palette.neutral.darkest};
  color: ${({ theme }) => theme.palette.neutral.lightest};
  display: flex;
  align-items: center;
  gap: .5rem;
  border-radius: 1.5rem;
  padding: 0.5rem .75rem;
  border: 1px solid ${({ theme }) => theme.palette.primary.medium};
  outline: none;

  &:hover {
    border-color: transparent;
    cursor: pointer;
  }

  &:focus,
  &:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: transparent;
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.palette.neutral.lightest};
  width: 1rem;
  height: 1rem;
`;